import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import Footer from "components/VerticalLayout/Footer";
import { get } from "helpers/api_helper";
import React, { useEffect, useState } from "react";
import * as api from "../../constants/api_constants.js";
import { useNavigate, useParams } from "react-router-dom";
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Table,
} from "reactstrap";

const ViewInvoice = () => {
  const [invoiceData, setInvoiceData] = useState({});
  const { invoiceId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    fetchInvoiceData();
  },[]);

  const fetchInvoiceData = async () => {
    try {
      const response = await get(api.GET_INVOICE_BY_ID(invoiceId));
      if (response) {
        setInvoiceData(response);
      }
    } catch (error) {}
  };

  if (!invoiceData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="page-content">
      {invoiceData.lineItems && invoiceData.lineItems.length > 0 && (
        <>
          <Container fluid className="p-0">
            <PageSubHeader
              heading={"View Invoice"}
              routePath={"Home"}
              pageName={"Invoices"}
            />

            <Card className="p-4">
              <Form>
                {/* Custom Settings Section */}
                <Row className="align-items-center">
                  <Col xs="2" className="text-primary">
                    Custom Settings:
                  </Col>
                  <Col md="3">
                    <Input
                      name="toCustomerCurrency"
                      type="select"
                      className="form-control"
                      disabled
                      value={invoiceData.currency}
                    >
                      <option>{invoiceData.currency}</option>
                    </Input>
                  </Col>
                  <Col className="d-flex gap-3 align-items-center">
                    <FormGroup
                      check
                      className="d-flex align-items-center gap-2"
                    >
                      <Input
                        type="checkbox"
                        id="taxRequiredCheckbox"
                        disabled
                        checked={
                          invoiceData.lineItems[0]?.taxType1 &&
                          invoiceData.lineItems[0]?.taxType2
                        }
                      />
                      <Label className="mb-0" for="taxRequiredCheckbox" check>
                        Tax
                      </Label>
                    </FormGroup>

                    <FormGroup
                      check
                      className="d-flex align-items-center gap-2"
                    >
                      <Input
                        type="checkbox"
                        id="poNumberRequiredCheckbox"
                        disabled
                        checked={!!invoiceData.poNumber}
                      />
                      <Label
                        className="mb-0"
                        for="poNumberRequiredCheckbox"
                        check
                      >
                        PO Number
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>

                <Row className="text-center mt-2">
                  <h1>INVOICE</h1>
                </Row>

                {/* From Customer Section */}
                <Row className="mb-5">
                  <Col md={6}>
                    <div className="py-3">
                      <h5>From Customer</h5>
                      <FormGroup>
                        <Input
                          type="text"
                          placeholder="From Company Name"
                          className="mb-3"
                          value={invoiceData.invoiceFromCustomer.companyName}
                          disabled
                        />
                      </FormGroup>
                      <FormGroup>
                        <Input
                          type="textarea"
                          rows={3}
                          placeholder="Enter Address.."
                          value={invoiceData.invoiceFromCustomer.address}
                          disabled
                        />
                      </FormGroup>
                    </div>
                  </Col>
                  {/* Logo Section (Disabled) */}
                  <Col md={6} className="text-end">
                    <div className="py-3">
                      {/* Logo placeholder can be added if needed */}
                    </div>
                  </Col>
                </Row>

                {/* To Customer Section */}
                <Row className="justify-content-between mb-4">
                  <Col md={6}>
                    <h5>To Customer</h5>
                    <FormGroup>
                      <Input
                        type="text"
                        placeholder="Customer Name"
                        className="mb-3"
                        value={invoiceData.invoiceToCustomer.companyName}
                        disabled
                      />
                    </FormGroup>

                    <FormGroup>
                      <Input
                        type="text"
                        placeholder="Customer Contact"
                        className="mb-3"
                        value={invoiceData.invoiceToCustomer.customerContact}
                        disabled
                      />
                    </FormGroup>

                    <FormGroup>
                      <Input
                        type="textarea"
                        placeholder="Customer Address"
                        rows="3"
                        className="mb-3"
                        value={invoiceData.invoiceToCustomer.address}
                        disabled
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label>Invoice #</Label>
                      <Input
                        type="text"
                        className="mb-3"
                        value={invoiceData.invoiceCode}
                        disabled
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label>Invoice Date</Label>
                      <Input
                        type="date"
                        className="mb-3"
                        value={invoiceData.invoiceDate}
                        disabled
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label>Due Date</Label>
                      <Input
                        type="date"
                        className="mb-3"
                        value={invoiceData.dueDate}
                        disabled
                      />
                    </FormGroup>

                    {invoiceData.poNumber && (
                      <FormGroup>
                        <Label>PO Number</Label>
                        <Input
                          type="text"
                          className="mb-3"
                          value={invoiceData.poNumber}
                          disabled
                        />
                      </FormGroup>
                    )}
                  </Col>
                </Row>

                {/* Line Items Section */}
                <div className="mb-4">
                  <Table responsive className="mb-0">
                    <thead>
                      <tr>
                        <th style={{ width: "12%" }}>Item</th>
                        <th style={{ width: "20%" }}>Description</th>
                        <th style={{ width: "12%" }}>Unit Price</th>
                        <th style={{ width: "10%" }}>Quantity</th>
                        <th style={{ width: "12%" }}>Tax 1</th>
                        <th style={{ width: "12%" }}>Tax 2</th>
                        <th style={{ width: "12%" }}>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoiceData.lineItems.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <Input type="text" value={item.itemType} disabled />
                          </td>
                          <td>
                            <Input
                              type="textarea"
                              value={item.description}
                              disabled
                              rows={3}
                            />
                          </td>
                          <td>
                            <Input
                              type="text"
                              value={item.unitPrice}
                              disabled
                            />
                          </td>
                          <td>
                            <Input type="text" value={item.quantity} disabled />
                          </td>
                          <td>
                            <Input type="text" value={item.taxType1} disabled />
                          </td>
                          <td>
                            <Input type="text" value={item.taxType2} disabled />
                          </td>
                          <td>
                            <Input type="text" value={item.subtotal} disabled />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                {/* Notes and Totals Section */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <label>Notes</label>
                      <Input
                        type="textarea"
                        rows="4"
                        value={invoiceData.notes || ""}
                        disabled
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <div className="border p-3">
                      <div className="d-flex justify-content-between mb-2">
                        <span>Subtotal:</span>
                        <span className="d-flex justify-content-between gap-2 w-25">
                          <div>{invoiceData.currency} </div>
                          <div>
                            {invoiceData.lineItems[0]?.subtotal.toFixed(2)}
                          </div>
                        </span>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span>
                          Tax 1 ({invoiceData.lineItems[0]?.taxType1}):
                        </span>
                        <span className="d-flex justify-content-between gap-2 w-25">
                          <div>{invoiceData.currency}</div>
                          <div>
                            {invoiceData.lineItems[0]?.taxAmount1.toFixed(2)}
                          </div>
                        </span>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span>
                          Tax 2 ({invoiceData.lineItems[0]?.taxType2}):
                        </span>
                        <span className="d-flex justify-content-between gap-2 w-25">
                          <div>{invoiceData.currency}</div>
                          <div>
                            {invoiceData.lineItems[0]?.taxAmount2.toFixed(2)}
                          </div>
                        </span>
                      </div>
                      <div className="d-flex justify-content-between mt-2">
                        <span className="fw-bold">Total Amount:</span>
                        <span className="fw-bold d-flex justify-content-between gap-2 w-25">
                          <div>{invoiceData.currency}</div>
                          <div>{invoiceData.total.toFixed(2)}</div>
                        </span>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Form>
            </Card>
          </Container>
          <Footer
            saveText="Edit Invoice"
            save={() => {
              navigate(`/add-invoice/${invoiceId}`);
            }}
            showBackConfirmation={false}
          />
        </>
      )}
    </div>
  );
};

export default ViewInvoice;
